import { useEffect, useRef, useState } from "react";
import {
    useKeyboardCommand,
    HOTKEYS_SCOPES,
} from "@hooks/keyboard/useKeyboardCommand";

/** Open state for a help menu: `?` opens it and focuses `firstItemRef`. */
export const useHelpMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const shouldSelectFirstItemRef = useRef(false);
    const firstItemRef = useRef<HTMLDivElement>(null);

    useKeyboardCommand({
        keys: "?",
        callback: () => {
            shouldSelectFirstItemRef.current = true;
            setIsOpen(true);
        },
        options: {
            description: "Help with",
            preventDefault: true,
            useKey: true,
            scopes: [HOTKEYS_SCOPES.GLOBAL],
        },
    });

    useEffect(() => {
        if (!isOpen || !shouldSelectFirstItemRef.current) {
            return;
        }

        shouldSelectFirstItemRef.current = false;

        const frameId = requestAnimationFrame(() => {
            firstItemRef.current?.focus();
        });

        return () => cancelAnimationFrame(frameId);
    }, [isOpen]);

    return { isOpen, setIsOpen, firstItemRef };
};
